import { Moment } from "moment";

export enum DateFiltersEnum {
  all = "all",
  current_month = "current_month",
  today = "today",
}

export type DateFilterConfig = {
  date_start: Moment;
  date_end: Moment;
};

export type DateFilter = keyof typeof DateFiltersEnum;
